import type { Domain } from '@thom/folio-domain/core/domain/domain'
import type { DomainFilter } from '@thom/folio-domain/core/ports/domains'
import type { Live } from '@thom/folio-domain/core/ports/live'
import { Collections } from '@thom/folio-ui/pocketbase-types'
import { columns, MEMBER_EXPAND, toDomain } from './domains-adapter'
import type { Realtime } from './realtime'

const MAX_ROWS = 500

const createDomainsLive = ({ client, connection }: Realtime): Live<Domain, DomainFilter> => ({
	source: { client, collection: Collections.JournDomains, map: toDomain, connection, expand: MEMBER_EXPAND },
	options: filter => ({ filter: columns(filter), sort: 'name', perPage: filter.limit ?? MAX_ROWS }),
})

export { createDomainsLive }
